var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C9.3138 0 12 2.6862 12 6C12 9.3138 9.3138 12 6 12C2.6862 12 0 9.3138 0 6C0 2.6862 2.6862 0 6 0ZM6 1.2C4.72696 1.2 3.50606 1.70571 2.60589 2.60589C1.70571 3.50606 1.2 4.72696 1.2 6C1.2 7.27304 1.70571 8.49394 2.60589 9.39411C3.50606 10.2943 4.72696 10.8 6 10.8C7.27304 10.8 8.49394 10.2943 9.39411 9.39411C10.2943 8.49394 10.8 7.27304 10.8 6C10.8 4.72696 10.2943 3.50606 9.39411 2.60589C8.49394 1.70571 7.27304 1.2 6 1.2ZM6.9 3C7.4475 2.99921 7.97366 3.21227 8.36636 3.59378C8.75905 3.97529 8.98722 4.49508 9.00224 5.04238C9.01726 5.58967 8.81795 6.1212 8.44678 6.52367C8.0756 6.92615 7.56192 7.16776 7.0152 7.197L6.9 7.2H5.4V8.4C5.39983 8.55293 5.34127 8.70002 5.23629 8.81122C5.13131 8.92242 4.98783 8.98934 4.83516 8.9983C4.6825 9.00727 4.53217 8.9576 4.4149 8.85944C4.29763 8.76129 4.22226 8.62206 4.2042 8.4702L4.2 8.4V4.2C4.1999 3.89725 4.31424 3.60566 4.5201 3.38367C4.72595 3.16168 5.00811 3.02571 5.31 3.003L5.4 3H6.9ZM6.9 4.2H5.4V6H6.9C7.13113 5.99989 7.35336 5.91085 7.52063 5.75136C7.68791 5.59186 7.78741 5.37411 7.79851 5.14325C7.80962 4.91239 7.73149 4.6861 7.58029 4.51128C7.4291 4.33646 7.21645 4.2265 6.9864 4.2042L6.9 4.2Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontParking);
export default __webpack_public_path__ + "static/media/front-parking.38dae2fcebd73441855cff0b15a094a8.svg";
export { ForwardRef as ReactComponent };